export const environment = {
  production: true,
  WebAPIUrl: 'https://portal-qs.npra.at/restapi'
  // ng build --deploy-url "/npraportal/" --environment=prod -prod -aot -vc -cc -dop --buildOptimizer
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts